import { EventEmitter } from '@flipster/utils/event-emitter';

export type SocketState = 'connecting' | 'connected' | 'closed';

export interface AbstractSocketEvents<Message = unknown> {
  message: Message;
  error: Error;
  stateChanged: SocketState;
  connecting: void;
  connected: void;
  closed: void;
  reconnectionLongTerm: void;
}

export default abstract class AbstractSocket<
  D extends unknown,
  E extends AbstractSocketEvents = AbstractSocketEvents,
> extends EventEmitter<E> {
  constructor() {
    super();
    this.on('stateChanged', () => {
      this.emit(this.state, undefined);
    });
    this.on('connected', () => {
      // connecting 중에 쌓인 메시지들 전송
      this.flushQueuedMessages();
    });
    this.on('closed', () => {
      // 소켓 연결이 끊어졌다 새 연결이 생기더라도 서버는 이전 세션에서의 상태를 알 수 없으므로
      // 이전 세션에 쌓였던 메시지들은 전부 폐기
      this.clearQueuedMessages();
    });
  }

  abstract connect(): void;
  abstract close(): void;
  abstract send(data: D): void;

  abstract get debugLabel(): string;
  abstract get state(): SocketState;

  protected abstract flushQueuedMessages(): void;
  protected abstract clearQueuedMessages(): void;

  reconnect(): void {
    this.close();
    this.connect();
  }
}
